import { t } from "@redotech/redo-i18n";
import { SubjectLineMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";

export const N_CHARACTERS_OF_QUERYSTRINGS_TO_SHOW = 15;

function queryPreview(queryStrings?: string[]): string {
  if (!queryStrings) {
    return "";
  }
  const joined = queryStrings.join(", ");
  return `"${joined.substring(0, N_CHARACTERS_OF_QUERYSTRINGS_TO_SHOW)}${joined.length > N_CHARACTERS_OF_QUERYSTRINGS_TO_SHOW ? "..." : ""}"`;
}

export const displayStringForMatchCondition = (
  nameOfCondition: "Message body" | "Subject line",
  matchMode: SubjectLineMatchType,
  queryStrings?: string[],
): string => {
  const query = queryPreview(queryStrings);
  if (nameOfCondition === "Message body") {
    return matchMode === SubjectLineMatchType.CONTAINS
      ? t("Message body includes: {{query}}", { query })
      : t("Message body is exactly: {{query}}", { query });
  }
  return matchMode === SubjectLineMatchType.CONTAINS
    ? t("Subject line includes: {{query}}", { query })
    : t("Subject line is exactly: {{query}}", { query });
};
